import React, { useEffect } from 'react';
import BlogCarousel from '../components/BlogCarousel/BlogCarousel';
import './Blog.css';

const Blog = () => {
  useEffect(() => {
    // Add no-scroll class to body when blog page mounts
    document.body.classList.add('blog-no-scroll');
    
    // Remove no-scroll class when blog page unmounts
    return () => {
      document.body.classList.remove('blog-no-scroll');
    };
  }, []);

  return (
    <div className="blog-page">
      <video autoPlay muted loop className="background-video">
        <source src="/blog-bg.mp4" type="video/mp4" />
        Your browser does not support HTML5 video.
      </video>
      <div className="blog-overlay">
        <div className="blog-container">
          <h1>My Blogs</h1>
          <p className="blog-description">
            Explore insights on technology, software craftsmanship, and AI revolutions.
          </p>
          <BlogCarousel />
        </div>
      </div>
    </div>
  );
};

export default Blog;
